import * as React from 'react';

import config from '../../../commonData';

import * as Yup from 'yup';
import { Formik } from 'formik';
import axios from 'axios';
import { Button, ButtonGroup, Col, Form, Modal, Placeholder, Row } from 'react-bootstrap';
import { Backspace, Save2Fill } from 'react-bootstrap-icons';
import dateformat from 'dateformat';

export default function AjouterCaisse({
    open,
    handleCloseModal,
    setOpenSnak,
    setLoad,
    load,
    idModif,
    setMsg,
    setSeverity,
    setActualise,
    actualise
}) {
    const [isLoading, setLoading] = React.useState(false);
    var ladate = new Date();
    const [state, setState] = React.useState({
        soldeinit: '',
        datecaisse: dateformat(ladate.getMonth() + 1 + '/' + ladate.getDate() + '/' + ladate.getFullYear(), 'yyyy-mm-dd')
    });

    React.useEffect(() => {
        setLoading(true);
        async function fetchDepense() {
            const response = await fetch(config.ipapi + '/api/caisse/' + idModif);
            const json = await response.json();

            setState((previousState) => {
                return {
                    ...previousState,
                    soldeinit: json.solde_init,
                    datecaisse: json.date_caisse
                };
            });
            setLoading(false);
        }
        if (idModif) {
            fetchDepense();
        } else {
            setState((previousState) => {
                return {
                    ...previousState,
                    soldeinit: '',
                    datecaisse: dateformat(ladate.getMonth() + 1 + '/' + ladate.getDate() + '/' + ladate.getFullYear(), 'yyyy-mm-dd')
                };
            });
            setLoading(false);
        }
    }, [idModif]);

    const { soldeinit, datecaisse } = state;

    return (
        <Formik
            initialValues={{
                soldeinit: soldeinit || 0,
                datecaisse: datecaisse,
                iduser: config.userid,
                societe: config.societe,
                app: 1,
                submit: null
            }}
            enableReinitialize
            validationSchema={Yup.object().shape({
                soldeinit: Yup.number().required('Veuillez cette donnée'),
                datecaisse: Yup.date().required(config.msg)
            })}
            onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
                try {
                    let url = idModif ? config.ipapi + '/api/update-caisse/' + idModif : config.ipapi + '/api/add-caisse';
                    await axios
                        .post(url, values)
                        .then((res) => {
                            if (res.data.status) {
                                setStatus({ success: true });
                                setOpenSnak(true);
                                setMsg(res.data.msg);
                                setSeverity('success');
                                setActualise(!actualise);
                                handleCloseModal();
                            } else {
                                setOpenSnak(true);
                                setStatus({ success: false });
                                setMsg(res.data.msg);
                                setSeverity('error');
                            }
                        })
                        .catch(() => {
                            setStatus({ success: false });
                        });
                    setSubmitting(false);
                } catch (err) {
                    setStatus({ success: false });
                    setErrors({ submit: err.message });
                    setSubmitting(false);
                }
            }}
        >
            {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
                <Modal show={open} onHide={handleCloseModal}>
                    <Modal.Header closeButton>{idModif ? 'MODIFIER LES DONNEES' : 'OUVERTURE DE CAISSE'}</Modal.Header>
                    <Form onSubmit={handleSubmit}>
                        <Modal.Body>
                            {isLoading ? (
                                <Placeholder xs={12} bg="secondary" />
                            ) : (
                                <Form.Group as={Row} className="mb-3" error={Boolean(touched.montantdepense && errors.montantdepense)}>
                                    <Form.Label column sm={4}>
                                        Solde initial
                                    </Form.Label>
                                    <Col sm="8">
                                        <Form.Control
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            id="soldeinit"
                                            value={values.soldeinit}
                                            label="Montant dépense"
                                            type="number"
                                            size="small"
                                            variant="standard"
                                            inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                                        />
                                        {touched.soldeinit && errors.soldeinit && (
                                            <Form.Control.Feedback error type="invalid">
                                                {errors.soldeinit}
                                            </Form.Control.Feedback>
                                        )}
                                    </Col>
                                </Form.Group>
                            )}
                            {isLoading ? (
                                <Placeholder xs={12} bg="secondary" />
                            ) : (
                                <Form.Group as={Row} className="mb-3" error={Boolean(touched.datecaisse && errors.datecaisse)}>
                                    <Form.Label column sm={4}>
                                        Date caisse
                                    </Form.Label>
                                    <Col sm="8">
                                        <Form.Control
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            id="datecaisse"
                                            value={values.datecaisse}
                                            label="Date de caisse"
                                            type="date"
                                            size="small"
                                            variant="standard"
                                        />
                                        {touched.datecaisse && errors.datecaisse && (
                                            <Form.Control.Feedback error type="invalid">
                                                {errors.datecaisse}
                                            </Form.Control.Feedback>
                                        )}
                                    </Col>
                                </Form.Group>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <input id="iduser" name="iduser" value={values.iduser} type="hidden" />
                            <input id="app" name="app" value={values.app} type="hidden" />
                            <div className="ml-auto">
                                <ButtonGroup size="sm">
                                    <Button variant="secondary" onClick={handleCloseModal}>
                                        <Backspace color="red" size={20} />
                                    </Button>
                                    <Button type="submit" variant="warning" disabled={isSubmitting}>
                                        <Save2Fill color="#807f7e" size={20} /> {idModif ? 'Modifier' : 'Ajouter'}
                                    </Button>
                                </ButtonGroup>
                            </div>
                        </Modal.Footer>
                    </Form>
                </Modal>
            )}
        </Formik>
    );
}
